export const tr = {
    'normal-view-title': 'Reklamlara 2. başlık ekleyin',
    'normal-view-title-hint': '2. başlığı olmayan reklamınız olduğu için bu öneriyi görüyorsunuz',
    'percent-value': '%{value}',
    'popup-view-title': 'Reklama 2. başlık ekleyin',
    'popup-view-title-hint': 'Reklamın 2. başlığı olmadığı için bu öneriyi görüyorsunuz',
    'show-many-banner-button': '{count} reklamı görüntüle',
    'show-one-banner-button': '{count} reklamı görüntüle',
    'show-some-banner-button': '{count} reklamı görüntüle',
    'title-extension-desc1':
        'Verilerimize göre 2. başlığa sahip reklamların CTR değeri masaüstü bilgisayarlarda {desktopValue}, mobil cihazlarda {mobileValue} oranında yükselir.',
    'title-extension-desc2':
        'Kullanıcıya teklifiniz hakkında daha fazla bilgi vermek için reklamınızda 2. başlığı kullanın. Dikkat: Ek başlık bazı durumlarda gösterilmediği için, 2. başlık olmadığında anlamın bozulmadığından emin olun.'
};
